import { combineReducers } from 'redux';
import { reducer as user } from './modules/user/reducer';
import { reducer as settings } from './modules/settings/reducer';
import { reducer as modal } from './modules/modal/reducer';

export const rootReducer = combineReducers({
  user,
  settings,
  modal,
});
